var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlowersLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 72,
    viewBox: "0 0 144 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14512_14017)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.8466 17.6229C43.8414 17.4701 43.961 17.342 44.1139 17.3368C44.2667 17.3316 44.3948 17.4513 44.4 17.6041C44.4052 17.757 44.2855 17.8851 44.1327 17.8903C43.9799 17.8955 43.8518 17.7758 43.8466 17.6229Z",
    stroke: "white",
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8466 17.6229C43.8414 17.4701 43.961 17.342 44.1139 17.3368C44.2667 17.3316 44.3948 17.4513 44.4 17.6041C44.4052 17.757 44.2855 17.8851 44.1327 17.8903C43.9799 17.8955 43.8518 17.7758 43.8466 17.6229Z",
    stroke: "#821FFF",
    strokeOpacity: 0.6,
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0846 41.7132C38.0812 41.6127 38.1599 41.5285 38.2604 41.5251C38.3609 41.5217 38.4451 41.6004 38.4485 41.7009C38.4519 41.8013 38.3732 41.8856 38.2728 41.889C38.1723 41.8924 38.088 41.8137 38.0846 41.7132Z",
    stroke: "white",
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0846 41.7132C38.0812 41.6127 38.1599 41.5285 38.2604 41.5251C38.3609 41.5217 38.4451 41.6004 38.4485 41.7009C38.4519 41.8013 38.3732 41.8856 38.2728 41.889C38.1723 41.8924 38.088 41.8137 38.0846 41.7132Z",
    stroke: "#821FFF",
    strokeOpacity: 0.6,
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0092 40.8349C34.004 40.682 34.1236 40.5539 34.2765 40.5487C34.4293 40.5435 34.5574 40.6632 34.5626 40.816C34.5678 40.9689 34.4481 41.097 34.2953 41.1022C34.1425 41.1074 34.0144 40.9877 34.0092 40.8349Z",
    stroke: "white",
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0092 40.8349C34.004 40.682 34.1236 40.5539 34.2765 40.5487C34.4293 40.5435 34.5574 40.6632 34.5626 40.816C34.5678 40.9689 34.4481 41.097 34.2953 41.1022C34.1425 41.1074 34.0144 40.9877 34.0092 40.8349Z",
    stroke: "#821FFF",
    strokeOpacity: 0.6,
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2033 21.7103C29.1998 21.6098 29.2785 21.5256 29.379 21.5222C29.4795 21.5187 29.5638 21.5974 29.5672 21.6979C29.5706 21.7984 29.4919 21.8827 29.3914 21.8861C29.2909 21.8895 29.2067 21.8108 29.2033 21.7103Z",
    stroke: "white",
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2033 21.7103C29.1998 21.6098 29.2785 21.5256 29.379 21.5222C29.4795 21.5187 29.5638 21.5974 29.5672 21.6979C29.5706 21.7984 29.4919 21.8827 29.3914 21.8861C29.2909 21.8895 29.2067 21.8108 29.2033 21.7103Z",
    stroke: "#821FFF",
    strokeOpacity: 0.6,
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3034 40.3317C20.0313 38.6869 24.1596 36.0948 24.7254 35.4342",
    stroke: "white",
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3034 40.3317C20.0313 38.6869 24.1596 36.0948 24.7254 35.4342",
    stroke: "#821FFF",
    strokeOpacity: 0.6,
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.9088 38.3233C20.4284 35.8577 23.0438 32.9718 24.9653 31.9994C28.174 30.3761 30.9903 32.8421 27.7247 35.9171C24.9961 38.4881 19.6536 38.7418 19.6536 38.7418",
    stroke: "white",
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9088 38.3233C20.4284 35.8577 23.0438 32.9718 24.9653 31.9994C28.174 30.3761 30.9903 32.8421 27.7247 35.9171C24.9961 38.4881 19.6536 38.7418 19.6536 38.7418",
    stroke: "#821FFF",
    strokeOpacity: 0.6,
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7608 41.1703C21.5244 39.7405 24.461 39.4926 25.4924 40.8049C26.5237 42.1171 24.6502 44.8336 19.8005 42.9529L17.4445 41.9703C17.4408 41.9742 18.4176 41.3452 18.7608 41.1703Z",
    stroke: "white",
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7608 41.1703C21.5244 39.7405 24.461 39.4926 25.4924 40.8049C26.5237 42.1171 24.6502 44.8336 19.8005 42.9529L17.4445 41.9703C17.4408 41.9742 18.4176 41.3452 18.7608 41.1703Z",
    stroke: "#821FFF",
    strokeOpacity: 0.6,
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3221 41.8203C23.3221 41.8203 19.2376 41.6821 17.6392 41.9983",
    stroke: "white",
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3221 41.8203C23.3221 41.8203 19.2376 41.6821 17.6392 41.9983",
    stroke: "#821FFF",
    strokeOpacity: 0.6,
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.405 33.4364C14.1656 29.0157 14.6865 26.0302 15.4659 22.6108C16.6378 17.4513 24.15 18.8354 21.1988 26.4692C20.2986 28.7921 18.757 30.5561 16.4416 32.1111C14.5047 33.4104 13.405 33.4364 13.405 33.4364Z",
    stroke: "white",
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.405 33.4364C14.1656 29.0157 14.6865 26.0302 15.4659 22.6108C16.6378 17.4513 24.15 18.8354 21.1988 26.4692C20.2986 28.7921 18.757 30.5561 16.4416 32.1111C14.5047 33.4104 13.405 33.4364 13.405 33.4364Z",
    stroke: "#821FFF",
    strokeOpacity: 0.6,
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1508 24.7889C18.1508 24.7889 15.2834 32.6551 10.5483 36.8238",
    stroke: "white",
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1508 24.7889C18.1508 24.7889 15.2834 32.6551 10.5483 36.8238",
    stroke: "#821FFF",
    strokeOpacity: 0.6,
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.79024 36.9622C4.4796 38.4868 3.63117 34.4055 3.87515 32.6515C4.14 30.7297 7.09189 30.8191 7.123 32.9623C7.1461 34.6466 6.20994 36.4697 5.79024 36.9622Z",
    stroke: "white",
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.79024 36.9622C4.4796 38.4868 3.63117 34.4055 3.87515 32.6515C4.14 30.7297 7.09189 30.8191 7.123 32.9623C7.1461 34.6466 6.20994 36.4697 5.79024 36.9622Z",
    stroke: "#821FFF",
    strokeOpacity: 0.6,
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.4714 33.8429L5.19829 37.4197",
    stroke: "white",
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.4714 33.8429L5.19829 37.4197",
    stroke: "#821FFF",
    strokeOpacity: 0.6,
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2759 40.193C20.0038 38.5482 24.1321 35.9562 24.6979 35.2956",
    stroke: "white",
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2759 40.193C20.0038 38.5482 24.1321 35.9562 24.6979 35.2956",
    stroke: "#821FFF",
    strokeOpacity: 0.6,
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.8813 38.1836C20.4009 35.7181 23.0164 32.8321 24.9378 31.8598C28.1465 30.2364 30.9628 32.7024 27.6973 35.7775C24.9687 38.3485 19.6261 38.6022 19.6261 38.6022",
    stroke: "white",
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8813 38.1836C20.4009 35.7181 23.0164 32.8321 24.9378 31.8598C28.1465 30.2364 30.9628 32.7024 27.6973 35.7775C24.9687 38.3485 19.6261 38.6022 19.6261 38.6022",
    stroke: "#821FFF",
    strokeOpacity: 0.6,
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7333 41.0316C21.4969 39.6018 24.4335 39.354 25.4649 40.6662C26.4962 41.9784 24.6227 44.6949 19.773 42.8142L17.417 41.8316C17.4171 41.8354 18.3902 41.2103 18.7333 41.0316Z",
    stroke: "white",
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7333 41.0316C21.4969 39.6018 24.4335 39.354 25.4649 40.6662C26.4962 41.9784 24.6227 44.6949 19.773 42.8142L17.417 41.8316C17.4171 41.8354 18.3902 41.2103 18.7333 41.0316Z",
    stroke: "#821FFF",
    strokeOpacity: 0.6,
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2981 41.6807C23.2981 41.6807 19.2136 41.5425 17.6152 41.8587",
    stroke: "white",
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2981 41.6807C23.2981 41.6807 19.2136 41.5425 17.6152 41.8587",
    stroke: "#821FFF",
    strokeOpacity: 0.6,
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.381 33.2967C14.1415 28.8761 14.6625 25.8905 15.4419 22.4712C16.6138 17.3116 24.1259 18.6958 21.1747 26.3295C20.2745 28.6524 18.7329 30.4164 16.4176 31.9715C14.4807 33.2707 13.381 33.2967 13.381 33.2967Z",
    stroke: "white",
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.381 33.2967C14.1415 28.8761 14.6625 25.8905 15.4419 22.4712C16.6138 17.3116 24.1259 18.6958 21.1747 26.3295C20.2745 28.6524 18.7329 30.4164 16.4176 31.9715C14.4807 33.2707 13.381 33.2967 13.381 33.2967Z",
    stroke: "#821FFF",
    strokeOpacity: 0.6,
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1272 24.6493C18.1272 24.6493 15.2598 32.5155 10.5247 36.6841",
    stroke: "white",
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1272 24.6493C18.1272 24.6493 15.2598 32.5155 10.5247 36.6841",
    stroke: "#821FFF",
    strokeOpacity: 0.6,
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.76619 36.8235C4.45556 38.3482 3.60712 34.2669 3.8511 32.5128C4.11595 30.591 7.06784 30.6804 7.09895 32.8236C7.12205 34.5079 6.1859 36.331 5.76619 36.8235Z",
    stroke: "white",
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.76619 36.8235C4.45556 38.3482 3.60712 34.2669 3.8511 32.5128C4.11595 30.591 7.06784 30.6804 7.09895 32.8236C7.12205 34.5079 6.1859 36.331 5.76619 36.8235Z",
    stroke: "#821FFF",
    strokeOpacity: 0.6,
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.44405 33.7033L5.17473 37.2799",
    stroke: "white",
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.44405 33.7033L5.17473 37.2799",
    stroke: "#821FFF",
    strokeOpacity: 0.6,
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.9772 85.0203C98.3089 78.4258 101.282 64.316 102.254 57.9814C102.84 54.1561 100.922 54.0476 99.8122 55.3712C94.8378 61.2778 89.0155 81.3525 88.3492 95.0228",
    stroke: "white",
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.9772 85.0203C98.3089 78.4258 101.282 64.316 102.254 57.9814C102.84 54.1561 100.922 54.0476 99.8122 55.3712C94.8378 61.2778 89.0155 81.3525 88.3492 95.0228",
    stroke: "#821FFF",
    strokeOpacity: 0.6,
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6007 84.4977C92.0612 73.704 93.2008 59.9705 91.8192 51.0865C91.6269 49.8747 90.2977 49.2572 89.505 50.9428C84.6718 61.2742 81.3214 79.9177 83.1413 94.3965",
    stroke: "white",
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6007 84.4977C92.0612 73.704 93.2008 59.9705 91.8192 51.0865C91.6269 49.8747 90.2977 49.2572 89.505 50.9428C84.6718 61.2742 81.3214 79.9177 83.1413 94.3965",
    stroke: "#821FFF",
    strokeOpacity: 0.6,
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1762 80.1464C69.8905 71.4294 68.7548 67.0477 67.8501 64.5277C66.4584 60.7091 64.5328 61.0908 63.9617 63.9687C63.2352 67.6728 62.5988 74.4724 63.835 79.475",
    stroke: "white",
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1762 80.1464C69.8905 71.4294 68.7548 67.0477 67.8501 64.5277C66.4584 60.7091 64.5328 61.0908 63.9617 63.9687C63.2352 67.6728 62.5988 74.4724 63.835 79.475",
    stroke: "#821FFF",
    strokeOpacity: 0.6,
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.653 74.3623C140.089 60.7568 135.497 60.3938 121.054 73.4521C119.353 74.9931 117.533 76.4927 115.987 78.0854",
    stroke: "white",
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.653 74.3623C140.089 60.7568 135.497 60.3938 121.054 73.4521C119.353 74.9931 117.533 76.4927 115.987 78.0854",
    stroke: "#821FFF",
    strokeOpacity: 0.6,
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4035 93.0492C62.8987 83.6199 56.9206 87.0681 45.5771 87.6814C31.7898 88.4277 27.3221 67.0523 10.7897 67.4239C1.66953 67.633 -3.18366 72.5176 -4.113 74.7745",
    stroke: "white",
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4035 93.0492C62.8987 83.6199 56.9206 87.0681 45.5771 87.6814C31.7898 88.4277 27.3221 67.0523 10.7897 67.4239C1.66953 67.633 -3.18366 72.5176 -4.113 74.7745",
    stroke: "#821FFF",
    strokeOpacity: 0.6,
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5065 70.59C76.1839 69.4924 76.2321 67.6245 77.8276 67.1556C79.3691 66.7025 80.4743 68.2313 80.7969 69.3289C81.1195 70.4265 80.3693 71.46 79.2354 71.9451C78.0073 72.4687 76.8291 71.6876 76.5065 70.59Z",
    stroke: "white",
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5065 70.59C76.1839 69.4924 76.2321 67.6245 77.8276 67.1556C79.3691 66.7025 80.4743 68.2313 80.7969 69.3289C81.1195 70.4265 80.3693 71.46 79.2354 71.9451C78.0073 72.4687 76.8291 71.6876 76.5065 70.59Z",
    stroke: "#821FFF",
    strokeOpacity: 0.6,
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3355 63.7066C73.095 62.8884 73.4867 61.5917 74.3707 61.3318C75.7074 60.9389 76.2858 61.9505 76.5263 62.7687C76.7668 63.5869 76.2489 64.4546 75.365 64.7144C74.481 64.9742 73.576 64.5248 73.3355 63.7066Z",
    stroke: "white",
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3355 63.7066C73.095 62.8884 73.4867 61.5917 74.3707 61.3318C75.7074 60.9389 76.2858 61.9505 76.5263 62.7687C76.7668 63.5869 76.2489 64.4546 75.365 64.7144C74.481 64.9742 73.576 64.5248 73.3355 63.7066Z",
    stroke: "#821FFF",
    strokeOpacity: 0.6,
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.233 71.3378C114.992 70.5196 115.513 69.5426 116.3 69.0728C118.04 68.0194 119.346 70.7899 117.434 72.0133C116.358 72.6979 115.473 72.156 115.233 71.3378Z",
    stroke: "white",
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.233 71.3378C114.992 70.5196 115.513 69.5426 116.3 69.0728C118.04 68.0194 119.346 70.7899 117.434 72.0133C116.358 72.6979 115.473 72.156 115.233 71.3378Z",
    stroke: "#821FFF",
    strokeOpacity: 0.6,
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4794 89.2057C78.1023 81.9152 72.3609 79.993 66.5107 79.7722C59.6748 79.505 54.118 81.5178 41.667 61.4699C29.216 41.4221 4.43917 49.8431 -7.1378 52.292C-8.28237 52.5417 -9.40831 52.7751 -10.5156 52.9922",
    stroke: "white",
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4794 89.2057C78.1023 81.9152 72.3609 79.993 66.5107 79.7722C59.6748 79.505 54.118 81.5178 41.667 61.4699C29.216 41.4221 4.43917 49.8431 -7.1378 52.292C-8.28237 52.5417 -9.40831 52.7751 -10.5156 52.9922",
    stroke: "#821FFF",
    strokeOpacity: 0.6,
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14512_14017"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 144,
    height: 72,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowersLeft);
export default __webpack_public_path__ + "static/media/flowers_left.723b1ce9503a11857c6b4f1c293795ae.svg";
export { ForwardRef as ReactComponent };